import { useState } from "react";
import { IoCloudUploadOutline, IoClose } from "react-icons/io5";

import Modal from "./../../../components/common/Modal";
import TextboxSearch from "../../../components/common/TextboxSearch";
import TableSize from "./../../../components/common/TableSize";
import TableControls from "./../../../components/common/TableControls";
import ReceiptForm from "./ReceiptForm";
import ReceiptFilter from "./ReceiptFilter";

import taxService from "../../../services/taxService";
import ReceiptExport from "./ReceiptExport";

const ReceiptHeader = ({ id, data, account, options, onChange, onSuccess }) => {
  const [showForm, setShowForm] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const quarters = taxService.getAltTaxQuarters();

  const settings = [
    {
      id: 1,
      content: (
        <TableSize size={options.size} onChange={(e) => handleSizeChange(e)} />
      ),
    },
  ];

  const handleSizeChange = (event) => {
    const size = event.target.value;

    if (size !== options.size) {
      const new_options = { ...options };
      new_options.size = size;
      new_options.current_page = 1;
      onChange(new_options);
    }
  };

  const handleSearch = (query) => {
    const new_options = { ...options };

    if (new_options.search_query !== query) {
      new_options.year = "";
      new_options.quarter = "";
      new_options.search_query = query;
      new_options.current_page = 1;
      onChange(new_options);
    }
  };

  const handleFilter = (year, quarter) => {
    const new_options = { ...options };
    new_options.year = year;
    new_options.quarter = quarter;
    onChange(new_options);
    setShowFilter(false);
  };

  const handleRemoveFilter = (item) => {
    const new_options = { ...options };
    if (item === 1) new_options["year"] = "";
    if (item === 2) new_options["quarter"] = "";
    onChange(new_options);
  };

  const renderQuarter = (quarter) => {
    const selected = quarters.filter((i) => i.value === quarter);
    return selected[0].label;
  };

  return (
    <>
      <div className="block lg:flex justify-between items-center">
        <div>
          <p className="text-gray-500 text-sm">Account Official Receipt</p>
          <span className="text-gray-400 text-xs">Official Receipts</span>
        </div>
        <div className="mt-5 lg:mt-0 block md:flex md:space-x-2">
          <TextboxSearch placeholder="Search..." onSearch={handleSearch} />
          <TableControls
            onFilter={() => setShowFilter(true)}
            settings={settings}
          />
          <ReceiptExport
            id={id}
            data={data}
            account={account}
            options={options}
          />
          <button
            className="button button-primary mt-2 md:mt-0"
            onClick={() => setShowForm(true)}
          >
            <IoCloudUploadOutline className="mr-2" />
            Upload Receipt
          </button>
        </div>
      </div>
      <div className="mt-1 float-right">
        <div className="flex gap-2">
          {options.year !== "" && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              {options.year}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(1)}
              />
            </div>
          )}
          {options.quarter !== "" && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              {renderQuarter(options.quarter)}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(2)}
              />
            </div>
          )}
        </div>
      </div>
      <Modal
        title="Upload Receipt"
        isOpen={showForm}
        isLoading={isLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <ReceiptForm
          id={id}
          isLoading={isLoading}
          setLoading={setIsLoading}
          setShowForm={setShowForm}
          onSuccess={onSuccess}
        />
      </Modal>
      <Modal
        title="Filter"
        isOpen={showFilter}
        onClose={() => setShowFilter(false)}
        borderTop
      >
        <ReceiptFilter options={options} onFilter={handleFilter} />
      </Modal>
    </>
  );
};

export default ReceiptHeader;
